var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 2H3C1.3125 2 0 3.375 0 5V27C0 28.6875 1.3125 30 3 30H29C30.625 30 32 28.6875 32 27V5C32 3.375 30.625 2 29 2ZM10 28H3C2.4375 28 2 27.5625 2 27V22H10V28ZM10 20H2V14H10V20ZM10 12H2V6H10V12ZM20 28H12V22H20V28ZM20 20H12V14H20V20ZM20 12H12V6H20V12ZM30 22V27C30 27.5625 29.5 28 29 28H22V22H30ZM30 20H22V14H30V20ZM30 12H22V6H30V12Z",
    fill: "#97AEB2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.43e93144.svg";
export { ForwardRef as ReactComponent };